import axiosClient from './axiosClient';
import { apiPath } from '../../utils/api-contants';
import { GatewayDataRequestPayloadTypes } from '../models/gateway-master-service';

const gatewayMasterService = {
  fetchGateways: async (payload: GatewayDataRequestPayloadTypes) => {
    try {
      const apiResponse: any = await axiosClient.get(apiPath.THINGS_GATEWAYS_BASE_URL, { params: payload });
      const res: any = apiResponse.data;
      return {
        status: 'success',
        code: res?.status,
        data: res,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: [],
      };
    }
  },
  getGateway: async (token: string, payload: any) => {
    try {
      const apiResponse: any = await axiosClient.get(`${apiPath.THINGS_GATEWAYS_BASE_URL}/${payload.gateway_id}`);
      const res: any = apiResponse.data;
      return {
        status: 'success',
        code: res?.status,
        data: res,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  addGateway: async (payload: any) => {
    try {
      const apiResponse = await axiosClient.post(apiPath.THINGS_GATEWAYS_BASE_URL, payload);
      return {
        status: 'success',
        code: apiResponse?.status,
        data: apiResponse.data,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  updateGateway: async (payload: any) => {
    try {
      const apiResponse = await axiosClient.patch(`${apiPath.THINGS_GATEWAYS_BASE_URL}/${payload.gateway_id}`, payload);
      return {
        status: 'success',
        code: apiResponse?.status,
        data: payload,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  removeGateway: async (payload: any) => {
    try {
      const apiResponse = await axiosClient.delete(`${apiPath.THINGS_GATEWAYS_BASE_URL}/${payload.gateway_id}`);
      return {
        status: 'success',
        code: apiResponse?.status,
        data: payload,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
};

export default gatewayMasterService;
